import React, { createContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { fetchWithRetry } from "../utils/fetchWithRetry";

export const StaticPagesContext = createContext();

const API_URL = "https://admin.thirsty-shtern.91-151-16-181.plesk.page/items/static_pages";

export const StaticPagesProvider = ({ children }) => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const ac = new AbortController();

    const fetchPages = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetchWithRetry(
          () =>
            axios.get(API_URL, {
              signal: ac.signal,
              params: {
                "filter[status][_eq]": "published",
                sort: "-date_updated",
                limit: -1,
                fields: "id,slug,title,content,status",
              },
            }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );

        const items = res?.data?.data ?? [];
        setPages(items);
      } catch (e) {
        if (!ac.signal.aborted) setError("Fehler beim Laden der Static Pages.");
      } finally {
        if (!ac.signal.aborted) setLoading(false);
      }
    };

    fetchPages();
    return () => ac.abort();
  }, []);

  const pagesBySlug = useMemo(() => {
    const map = {};
    for (const p of pages || []) {
      if (p?.slug) map[p.slug] = p;
    }
    return map;
  }, [pages]);

  const getPage = (slug) => (slug ? pagesBySlug[slug] ?? null : null);

  return (
    <StaticPagesContext.Provider
      value={{
        pages,
        pagesBySlug,
        getPage,
        loading,
        error,
      }}
    >
      {children}
    </StaticPagesContext.Provider>
  );
};
